import { RegistryItemStatusCodeType } from '@/api/backend/types';
import { Badge } from '@opaz/ui-components';
import { useTranslation } from 'react-i18next';

type BadgeType = 'positive' | 'negative' | 'warning' | 'neutral' | 'brand' | null | undefined;

const registryStatusToBadgeTypeMap: Record<string, BadgeType> = {
  ACTIVE: 'positive',
  PENDING: 'warning',
  EXPIRED: 'negative',
  COMPLETED: 'positive',
  SUSPENDED: 'negative',
  CANCELED: 'negative',
};

type RegistryStatusBadgeProps = {
  statusCode: RegistryItemStatusCodeType;
};

export const RegistryStatusBadge = ({ statusCode }: RegistryStatusBadgeProps) => {
  const { t } = useTranslation();

  return (
    <Badge filled type={registryStatusToBadgeTypeMap[statusCode] || 'neutral'}>
      {t(`registry.status.${statusCode ?? 'UNKNOWN'}`)}
    </Badge>
  );
};
